module.exports = __webpack_public_path__ + "img/kv_img_1.894c3f3b.png";